import { motion } from "framer-motion";
import { CalendarDays, ArrowRight, CheckCircle2, Star, Award } from "lucide-react";

const REASSURANCE = [
  "Déplacement gratuit",
  "Devis sans engagement",
  "Réponse rapide",
];

/**
 * CTA principal de la page d'accueil : réservation d'un devis gratuit
 * à domicile (remplace l'ancien Estimateur IA).
 */
export default function BookingCta() {
  return (
    <section
      id="rdv-devis"
      data-testid="booking-cta-section"
      className="relative py-24 md:py-32 bg-gradient-to-b from-[#050505] via-[#0a0a0a] to-[#050505]"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          data-testid="booking-cta-card"
          className="group relative overflow-hidden rounded-3xl border border-[#FF5A00]/25 bg-gradient-to-br from-[#FF5A00]/8 via-[#0a0a0a] to-[#0a0a0a] p-8 md:p-12 text-center transition-all hover:border-[#FF5A00]/60 hover:shadow-2xl hover:shadow-[#FF5A00]/10"
        >
          <div
            aria-hidden
            className="absolute -top-20 -right-20 w-72 h-72 rounded-full bg-[#FF5A00]/12 blur-3xl pointer-events-none transition-opacity opacity-70 group-hover:opacity-100"
          />
          <div
            aria-hidden
            className="absolute -bottom-24 -left-24 w-64 h-64 rounded-full bg-[#FF5A00]/8 blur-3xl pointer-events-none"
          />

          <div className="relative flex flex-col items-center">
            <div className="w-14 h-14 rounded-2xl bg-[#FF5A00]/15 border border-[#FF5A00]/35 flex items-center justify-center mb-6">
              <CalendarDays size={24} className="text-[#FF5A00]" />
            </div>

            <div className="eyebrow mb-4 inline-flex items-center gap-2">
              <span>Visite d&apos;un expert · Gratuit</span>
            </div>

            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-light text-white leading-tight mb-4">
              📅 Réserver mon devis gratuit
              <br className="hidden md:block" />{" "}
              <em className="text-[#FF5A00] not-italic font-normal">à domicile</em>
            </h2>

            <p className="text-neutral-300 text-base md:text-lg leading-relaxed max-w-xl mb-8">
              Un expert GMC se déplace gratuitement chez vous pour établir un
              devis précis, sans engagement.
            </p>

            <a
              href="/devis"
              data-testid="booking-cta-button"
              className="btn-primary btn-pulse text-base md:text-lg px-8 py-4"
            >
              Réserver <ArrowRight size={18} />
            </a>

            <div
              data-testid="booking-cta-reassurance"
              className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6"
            >
              {REASSURANCE.map((item) => (
                <span
                  key={item}
                  className="inline-flex items-center gap-2 text-sm text-neutral-300"
                >
                  <CheckCircle2 size={15} className="text-[#FF5A00] shrink-0" />
                  {item}
                </span>
              ))}
            </div>
          </div>
        </motion.div>

        {/* Preuve sociale — rassure juste avant le clic */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.25 }}
          data-testid="booking-cta-social-proof"
          className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-8 text-sm text-neutral-400"
        >
          <span className="inline-flex items-center gap-2">
            <span className="inline-flex items-center gap-0.5" aria-hidden>
              {[...Array(5)].map((_, i) => (
                <Star key={`star-${i + 1}`} size={13} className="text-[#FF5A00] fill-[#FF5A00]" />
              ))}
            </span>
            <span>
              <strong className="text-white font-medium">5/5</strong> sur Google
            </span>
          </span>
          <span className="hidden sm:block w-px h-4 bg-white/15" aria-hidden />
          <span className="inline-flex items-center gap-2">
            <Award size={15} className="text-[#FF5A00]" />
            <span>
              <strong className="text-white font-medium">25 ans</strong>{" "}
              d&apos;expérience
            </span>
          </span>
        </motion.div>
      </div>
    </section>
  );
}
